import { useEffect, useState, FC } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import classnames, { Mapping } from "classnames";
import "./index.scss";
import Icon from "@assets/icon_config";

const { RangePicker } = DatePicker;

interface DateRangeProps {
  rangeStartDate?: any;
  rangeEndDate?: any;
  format?: any;
  format_1?: any;
  format_2?: any;
  disabledDates?: any;
  className?: string | number | boolean | Mapping | null | undefined;
  picker?: "time" | "date" | "week" | "month" | "quarter" | "year" | undefined;
  handleDateChange?: any;
  disabledDate?: ((date: moment.Moment) => boolean) | undefined;
  onOpenChange?: (arg0: boolean) => void;
}

export const DateRange: FC<DateRangeProps> = (props) => {
  const [startDate, setStartDate] = useState(props.rangeStartDate);
  const [endDate, setEndDate] = useState(props.rangeEndDate);

  const _format = props.format ? props.format : "MMM'YY";
  const format_1 = props.format_1 ? props.format_1 : "YYYY-MM";
  const format_2 = props.format_2 ? props.format_2 : "YYYY/MM";
  const disabledDates = props.disabledDates ? props.disabledDates : [false, false];

  useEffect(() => {
    console.log("DateRange.useEffect");
    setStartDate(props.rangeStartDate);
    setEndDate(props.rangeEndDate);
  }, [props.rangeEndDate, props.rangeStartDate]);

  const _className = classnames("ui-population-insight__header__filter__date", props.className);
  const isNoBorderTheme = props.className === "noBorder" || props.className === "color-orange";

  return (
    <div className={_className}>
      {isNoBorderTheme ? <Icon name="calender" colorOfBrand="#0072e3" /> : <span className="ui-population-insight__header__filter__date__icon icon-calendar f18" />}

      <RangePicker
        picker={props.picker ? props.picker : "month"}
        size={isNoBorderTheme ? "small" : "large"}
        format={_format}
        clearIcon={false}
        onChange={(date: any) => {
          setStartDate(date[0].format(format_1));
          setEndDate(date[1].format(format_1));
          props.handleDateChange([date[0].format(format_1), date[1].format(format_1)]);
        }}
        value={startDate ? [moment(startDate, format_2).isValid() ? moment(startDate, format_2) : null, moment(endDate, format_2).isValid() ? moment(endDate, format_2) : null] : undefined}
        disabled={disabledDates}
        disabledDate={props.disabledDate}
        onOpenChange={(open) => {
          if (props.onOpenChange) {
            props.onOpenChange(open);
          }
        }}
        placeholder={["--/--/--", "--/--/--"]}
      />
    </div>
  );
};
export const DateRangePreloader = () => {
  return (
    <div className="ui-population-insight__header__filter__date-range-preloader">
      <div className="ui-population-insight__header__filter__date-range-preloader__title shimmerBG" />
    </div>
  );
};
